// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Roles_pageWrap__emZnG {
  padding: 4px 4px 32px;
}

.Roles_desktopTable__jKiUH {
  display: block;
}

.Roles_mobileList__oqpwz {
  display: none;
}

@media (max-width: 767px) {
  .Roles_desktopTable__jKiUH {
    display: none;
  }
  .Roles_mobileList__oqpwz {
    display: block;
  }
}

.Roles_sectionTitle__YyQoE {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #4c2fb3;
  margin: 26px 24px 14px;
  padding-top: 14px;
  border-top: 1px solid #EEF0F6;
}

.Roles_emptyState__LdHk0 {
  text-align: center;
  color: #9CA3AF;
  font-size: 13.5px;
  padding: 40px 0;
}

/* =========================================================
   Status pills
   ========================================================= */
.Roles_pillBase__0ktur {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.Roles_pillGreen__hsPK\\+ { background: #E9F9EF; color: #16A34A; }
.Roles_pillRed__Hk0cw { background: #FDEDED; color: #DC2626; }

/* =========================================================
   Mobile card list
   ========================================================= */
.Roles_mobileCard__SCjVp {
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 12px;
}

.Roles_mobileRow__BhYpj {
  display: flex;
  gap: 12px;
  padding: 4px 0;
  font-size: 13px;
}

.Roles_mobileLabel__l4v9- {
  min-width: 90px;
  flex-shrink: 0;
  color: #6B7280;
  font-weight: 600;
}

.Roles_mobileValue__ELnZh {
  color: #1F2430;
}

.Roles_mobileActionRow__P4t9f {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

/* =========================================================
   Permission matrix — restyle the existing MUI Table via
   its default generated classnames, without touching any
   of the checkbox bindings.
   ========================================================= */
.Roles_permTableWrap__jweKb {
  margin: 4px 24px 24px;
}

.Roles_permTableWrap__jweKb .MuiTableContainer-root {
  border-radius: 14px !important;
  border: 1px solid #E7E9F1 !important;
  box-shadow: none !important;
  overflow: hidden !important;
}

.Roles_permTableWrap__jweKb .MuiTableCell-root {
  padding: 10px 14px !important;
  border-bottom: 1px solid #F1F2F6 !important;
  font-size: 13px !important;
}

.Roles_permTableWrap__jweKb .MuiTableHead-root .MuiTableRow-root:first-child .MuiTableCell-root {
  background: #F5F3FE !important;
  color: #4c2fb3 !important;
  font-weight: 700 !important;
  font-size: 11.5px !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #E7E9F1 !important;
}

.Roles_permTableWrap__jweKb .MuiTableHead-root .MuiTableRow-root:not(:first-child) .MuiTableCell-root:first-child {
  font-weight: 700 !important;
  color: #1F2430 !important;
  text-align: left !important;
  background: #FAFAFC !important;
}

.Roles_permTableWrap__jweKb .MuiTableHead-root .MuiTableRow-root:not(:first-child):hover .MuiTableCell-root {
  background: #FAF8FF !important;
}

.Roles_permTableWrap__jweKb input[type="checkbox"] {
  width: 17px;
  height: 17px;
  accent-color: #4c2fb3;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/roles/Roles.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,2BAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,wBAAW,mBAAmB,EAAE,cAAc,EAAE;;AAEhD;;8DAE8D;AAC9D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;;;8DAI8D;AAC9D;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.desktopTable {\n  display: block;\n}\n\n.mobileList {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .desktopTable {\n    display: none;\n  }\n  .mobileList {\n    display: block;\n  }\n}\n\n.sectionTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #4c2fb3;\n  margin: 26px 24px 14px;\n  padding-top: 14px;\n  border-top: 1px solid #EEF0F6;\n}\n\n.emptyState {\n  text-align: center;\n  color: #9CA3AF;\n  font-size: 13.5px;\n  padding: 40px 0;\n}\n\n/* =========================================================\n   Status pills\n   ========================================================= */\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.pillGreen { background: #E9F9EF; color: #16A34A; }\n.pillRed { background: #FDEDED; color: #DC2626; }\n\n/* =========================================================\n   Mobile card list\n   ========================================================= */\n.mobileCard {\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  background: #ffffff;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.mobileRow {\n  display: flex;\n  gap: 12px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.mobileLabel {\n  min-width: 90px;\n  flex-shrink: 0;\n  color: #6B7280;\n  font-weight: 600;\n}\n\n.mobileValue {\n  color: #1F2430;\n}\n\n.mobileActionRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n/* =========================================================\n   Permission matrix — restyle the existing MUI Table via\n   its default generated classnames, without touching any\n   of the checkbox bindings.\n   ========================================================= */\n.permTableWrap {\n  margin: 4px 24px 24px;\n}\n\n.permTableWrap :global(.MuiTableContainer-root) {\n  border-radius: 14px !important;\n  border: 1px solid #E7E9F1 !important;\n  box-shadow: none !important;\n  overflow: hidden !important;\n}\n\n.permTableWrap :global(.MuiTableCell-root) {\n  padding: 10px 14px !important;\n  border-bottom: 1px solid #F1F2F6 !important;\n  font-size: 13px !important;\n}\n\n.permTableWrap :global(.MuiTableHead-root .MuiTableRow-root:first-child .MuiTableCell-root) {\n  background: #F5F3FE !important;\n  color: #4c2fb3 !important;\n  font-weight: 700 !important;\n  font-size: 11.5px !important;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #E7E9F1 !important;\n}\n\n.permTableWrap :global(.MuiTableHead-root .MuiTableRow-root:not(:first-child) .MuiTableCell-root:first-child) {\n  font-weight: 700 !important;\n  color: #1F2430 !important;\n  text-align: left !important;\n  background: #FAFAFC !important;\n}\n\n.permTableWrap :global(.MuiTableHead-root .MuiTableRow-root:not(:first-child):hover .MuiTableCell-root) {\n  background: #FAF8FF !important;\n}\n\n.permTableWrap :global(input[type=\"checkbox\"]) {\n  width: 17px;\n  height: 17px;\n  accent-color: #4c2fb3;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `Roles_pageWrap__emZnG`,
	"desktopTable": `Roles_desktopTable__jKiUH`,
	"mobileList": `Roles_mobileList__oqpwz`,
	"sectionTitle": `Roles_sectionTitle__YyQoE`,
	"emptyState": `Roles_emptyState__LdHk0`,
	"pillBase": `Roles_pillBase__0ktur`,
	"pillGreen": `Roles_pillGreen__hsPK+`,
	"pillRed": `Roles_pillRed__Hk0cw`,
	"mobileCard": `Roles_mobileCard__SCjVp`,
	"mobileRow": `Roles_mobileRow__BhYpj`,
	"mobileLabel": `Roles_mobileLabel__l4v9-`,
	"mobileValue": `Roles_mobileValue__ELnZh`,
	"mobileActionRow": `Roles_mobileActionRow__P4t9f`,
	"permTableWrap": `Roles_permTableWrap__jweKb`
};
export default ___CSS_LOADER_EXPORT___;
